module.exports = __webpack_public_path__ + "static/error-04d8ee22d52bbfc9e66ee88fd3f98b30.svg";